export const SERVICES = [
  {
    id: "01",
    title: "Brand Activations",
    lead: "Ideas people can walk into. Activations that translate a brand story into a room, a street, a stage.",
    tags: ["Concept", "Design", "Fabrication"],
  },
  {
    id: "02",
    title: "Sponsorship Integrations",
    lead: "Native integrations between brands and moments — no logo dumps, only meaningful presence.",
    tags: ["Strategy", "Partnerships", "Rights"],
  },
  {
    id: "03",
    title: "Product Launches",
    lead: "Launches designed to be shared, remembered, and re-watched — from teaser to keynote.",
    tags: ["Reveal", "Press", "Live"],
  },
  {
    id: "04",
    title: "Content & Visual Production",
    lead: "In-house film, motion and photography — capturing the moment as sharply as we build it.",
    tags: ["Film", "Photo", "Post"],
  },
];

export const VERTICALS = [
  { n: "V/01", label: "Music & Lifestyle Festivals" },
  { n: "V/02", label: "Corporate Events" },
  { n: "V/03", label: "Bespoke Experiences" },
  { n: "V/04", label: "Artist Management" },
  { n: "V/05", label: "Venue Partnerships" },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Events are edited, not organized.",
    body: "We cut, sequence and pace an event like an editor cuts a film — every beat earns its place. Anything that doesn't move the audience forward gets removed.",
  },
  {
    n: "02",
    title: "The venue is the second act.",
    body: "A room is not a backdrop — it is a co-performer. We design light, sound and staging as a single instrument that the audience feels before it sees.",
  },
  {
    n: "03",
    title: "Sponsors are storytellers, not stickers.",
    body: "Every brand we bring on becomes a chapter in the narrative — with a reason to exist inside the moment, not stuck on top of it.",
  },
  {
    n: "04",
    title: "If it can't be shared, we didn't finish.",
    body: "Every event has a second life online. We build shareable moments into the script — a shot, a phrase, a reveal designed to travel.",
  },
];

export const PORTFOLIO = [
  {
    title: "NEON MONSOON",
    kind: "Music Festival · Kochi",
    year: "2025",
    img: "https://images.unsplash.com/photo-1506157786151-b8491531f063?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxtdXNpYyUyMGZlc3RpdmFsJTIwY3Jvd2QlMjBsaWdodHN8ZW58MHx8fHwxNzgzNjU5OTYzfDA&ixlib=rb-4.1.0&q=85",
    span: "col-span-12 md:col-span-8 row-span-2",
    ratio: "aspect-[16/10]",
  },
  {
    title: "AXIS KEYNOTE '25",
    kind: "Product Launch · Bengaluru",
    year: "2025",
    img: "https://images.unsplash.com/photo-1768508948210-a74bb6f9b32d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBldmVudCUyMHN0YWdlJTIwcHJlc2VudGF0aW9ufGVufDB8fHx8MTc4MzY1OTk2M3ww&ixlib=rb-4.1.0&q=85",
    span: "col-span-12 md:col-span-4",
    ratio: "aspect-[4/5]",
  },
  {
    title: "HALO ROOMS",
    kind: "Bespoke Experience · Mumbai",
    year: "2024",
    img: "https://images.unsplash.com/photo-1748525938712-a065b4396ba4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxpbW1lcnNpdmUlMjBsaWdodCUyMGFydCUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3ODM2NTk5NjN8MA&ixlib=rb-4.1.0&q=85",
    span: "col-span-12 md:col-span-5",
    ratio: "aspect-[4/5]",
  },
  {
    title: "OFF-RECORD",
    kind: "Content Series · Kochi",
    year: "2024",
    img: "https://images.unsplash.com/photo-1496559249665-c7e2874707ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHx2aWRlb2dyYXBoZXIlMjBmaWxtaW5nJTIwZXZlbnR8ZW58MHx8fHwxNzgzNjU5OTYzfDA&ixlib=rb-4.1.0&q=85",
    span: "col-span-12 md:col-span-7",
    ratio: "aspect-[16/10]",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Event Monk didn't build us an event — they built us a language. Six months later, people are still quoting the visuals.",
    name: "Aisha Menon",
    role: "Head of Brand, Halo Records",
    img: "https://images.unsplash.com/photo-1607796884038-3638822d5ee2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxuZW9uJTIwcG9ydHJhaXQlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzgzNjU5OTYzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "The keynote felt like a film, not a slide deck. Our launch outperformed every KPI we set — and every metric we didn't.",
    name: "Rohit Varma",
    role: "VP Marketing, Axis Devices",
    img: "https://images.unsplash.com/photo-1607796884038-3638822d5ee2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxuZW9uJTIwcG9ydHJhaXQlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzgzNjU5OTYzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "Sponsors kept asking us who choreographed the room. That's Event Monk — precision disguised as chaos.",
    name: "Neha Kurian",
    role: "Festival Director, Neon Monsoon",
    img: "https://images.unsplash.com/photo-1607796884038-3638822d5ee2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxuZW9uJTIwcG9ydHJhaXQlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzgzNjU5OTYzfDA&ixlib=rb-4.1.0&q=85",
  },
];

export const JOURNAL = [
  {
    tag: "Field Notes",
    date: "Nov 2025",
    title: "On staging silence: the pause is the loudest instrument.",
    read: "6 min read",
  },
  {
    tag: "Case Study",
    date: "Oct 2025",
    title: "How Neon Monsoon turned a monsoon warning into its opening credits.",
    read: "9 min read",
  },
  {
    tag: "Playbook",
    date: "Sep 2025",
    title: "Sponsor integrations that people screenshot, not skip.",
    read: "5 min read",
  },
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_8084a559-6865-4bbe-99ba-b84fac81f6f2/artifacts/q370iyss_EventMonk%20Logo.png";
